import { BaseModel } from "../base.model";

export class PatientDetail extends BaseModel {
  MaritialStatusId: number = 0;
  LicenseStateId: number = 0;
  DOB: string = '';
  InsuranceNumber: string = '';
  PatientNumber: number = 0;
  MRNNumber: string = '';
  // SSNNumber: string = '';
  MaidenName: string = '';
  LicenseNumber: string = '';
  Country: string = '';
  State: string = '';
  City: string = '';
  Zip: string = '';
  HomePhone: string = '';
  Mobile: string = '';
  Email: string = '';
  InsuranceRelationship: string = '';
  Sex: string = '';
  DisplayInList: boolean = true;
  MaritalStatus: string = '';
  LicenseState: string = '';
  SexialOriendation: string = '';
  GenderIdentity: string = '';
  Languages: string = '';
  RelationShipToContact: string = '';
  ResponsibleParty: string = '';
  PaymentMethod: string = '';
  UploadImagePath: string = '';
  UploadImageName: string = '';
  IsPatientIntake: boolean = false;
  ModifiedUser: string = '';
  DefaultPOCTemplate?: boolean;
  SubscriberId: number;
}

export class Patient extends PatientDetail {
  AdditionalDetail: PatientAdditionalDetail = new PatientAdditionalDetail();
  Contact: PatientContact = new PatientContact();
  EmergencyContact: PatientContact = new PatientContact();
  Demograph: PatientDemograph = new PatientDemograph();
  OtherContact: PatientContact = new PatientContact();
  Insurance: Array<PatientInsurance> = new Array<PatientInsurance>();
  Language: Array<PatientLanguage> = new Array<PatientLanguage>();
  ProfileAttachment: PatientAttachment = new PatientAttachment();
  Race: Array<PatientRace> = new Array<PatientRace>();
  Ethnicity: Array<PatientEthnicity> = new Array<PatientEthnicity>();
  SelfPay: Array<InsuranceCase> = new Array<InsuranceCase>();
  PatientBalance: number = 0;
  UserImage: any;
  Profile: any;
}

export class PatientInfo extends BaseModel {
  PatientId :number = 0 ;
  FullName :string = '';
  DOB:string = '';
  PatientNumber:string='';
  PrimaryPhone:string='';
  MobilePhone:string='';
  HomePhone:string='';
  EmailId:string='';
  GenderName:string='';
  Suite:string='';
  PrimaryContact:string='';
  ZipCode:string='';
  CountryName:string='';
  Address:string='';
  City:string='';
  StateName:string='';
  ECFullName:string='';
  ECDOB:string='';
  RelationShip:string='';
  ECPrimaryPhone:string='';
  ECMobilePhone:string='';
  ECHomePhone:string='';
  ECEmailId:string='';
  ECSuite:string='';
  ECZipCode:string='';
  ECCountryName:string='';
  ECStateName:string='';
  ECAddress:string='';
  MaritalStatus:string='';
  MaidenName:string='';
  LicenseNumber:string='';
  LicenseState:string='';
  LicenceFileName:string='';
}

export class PatientAdditionalDetail extends BaseModel {
  PatientId: number = 0;
  CitizenShipId: number = 0;
  NationalityId: number = 0;
  ProviderId: number = 0;
  ReferringProviderId: number = 0;
  ResponsiblePartyTypeId: number = 0;
  PaymentTypeId: number = 0;
  MotherName: string = '';
  MotherMaidenName: string = '';
  MaidenName: string = '';
  BirthOrder: number;
  BirthPlace: string = '';
  MultipleBirthNumber: string = '';
  Education: string = '';
  Religious: string = '';
  DateOfDeath: any;
  CauseOfDeath: string = '';
  ReferalSource: string = '';
  Notes: string = '';
  StatusId: number = 0;
  PasswordType: number = 0;
  PasswordExpiryDate: string = '';
  DOB: string = '';
  // SSNNumber: string = '';
}

export class PatientContact extends BaseModel {
  PatientId: number = 0;
  ContactTypeId: number = 0;
  CountryId: number = 1;
  StateId: number = 0;
  CityId: number = 0;
  ZipId: number = 0;
  PreferredContactId: number = 0;
  RelationshipId: number = 0;
  Address: string = '';
  Suite: string = '';
  MobilePhone: string = '';
  WorkPhone: string = '';
  HomePhone: string = '';
  FaxNumber: string = '';
  FirstName: string = '';
  MiddleName: string = '';
  LastName: string = '';
  Suffix: string = '';
  EmailId: string = '';
  // SSNNumber: string = '';
  DOB: string = '';
  GenderId : number = 0 ;
  PrimaryFirstName: string = '';
  PrimaryLastName: String = '';
}

export class PatientDemograph extends BaseModel {
  PatientId: number = 0;
  SexualOrientationId: number = 0;
  GenderId: number = 0;
  RaceId: number = 0;
  Hispanic: string = '';
  IsDecline: boolean = false;
}

export class PatientInsurance extends BaseModel {
  PatientId: number = 0;
  RelationshipId: number = 0;
  ContactId: number;
  CompanyName: string = '';
  PolicyNumber: string = '';
  PlanName: string;
  InsurancePhone: string = '';
  GroupNumber: string = '';
  StartDate: string = '';
  EndDate: string = '';
  RowOrder: number = 0;
  IsPrimary: boolean = false;
  InsuranceCaseId: number = 0;
  CaseTypeId: number = 0;
  AutharizationName: string = '';
  CaseName: string = '';
  NoOfUnits: number = 0;
  PriorCount: number = 0;
  PaymentMethodId: number = 0;
  InsuranceAttachment: Array<PatientAttachment> = new Array<PatientAttachment>();
  Authorization: Array<InsuranceCase> = new Array<InsuranceCase>();
  InsuranceContact: PatientContact = new PatientContact();
  Relationship: string = '';
  CopayAmount: string = '';
  NAME: string = '';
  effectivestartdate: string = '';
  effectiveenddate: string = '';
  InsuranceProviderId: number = 0;

}
export class InsuranceCase extends BaseModel {
  InsuranceId: number = 0;
  StartDate: string = '';
  EndDate: string = '';
  CaseTypeId: number = 0;
  AuthNumber: string = '';
  NoOfUnits: number = 0;
  Name: string = '';
  PhoneNumber: string = '';
  Notes: string = '';
  RowOrder: number = 0;
  PatientId: number = 0;
  PriorCount: number = 0;
  IsPrimary: boolean = false;
  InsuranceCaseId: number = 0;
  AutharizationName: string = '';
  CaseName: string = '';
  PaymentMethodId: number = 0;
  effectivestartdate: string = '';
  effectiveenddate: string = '';
  CompanyName: string = '';
  InsuranceProviderId: number = 0;
  IsCaseRequired: boolean = false;
  InsuranceCaseName: string = '';
}
export class PatientLanguage extends BaseModel {
  PatientId: number = 0;
  LanguageId: number = 0;
  RowOrder: number = 0;
  Name: string = '';
}

export class PatientRace extends BaseModel {
  PatientId: number = 0;
  SpecificRaceId: number = 0;
  RowOrder: number = 0;
}

export class PatientEthnicity extends BaseModel {
  PatientId: number = 0;
  EthnicityId: number = 0;
  RowOrder: number = 0;
}

export class PatientAttachment extends BaseModel {
  PatientId: number = 0;
  AttachmentTypeId: number = 0;
  InsuranceId: number = 0;
  UploadFileName: string = '';
  UploadFilePath: string = '';
  DisplayName: string = '';
  File: any[];
  RowOrder: number = 0;
  DirtyAttachment: boolean = false;
}

export class PatientInsuranceInfo extends BaseModel {
  PatientId: number = 0;
  RelationshipId: number = 0;
  ContactId: number;
  CompanyName: string = '';
  PolicyNumber: string = '';
  PlanName: string;
  InsurancePhone: string = '';
  GroupNumber: string = '';
  StartDate: string = '';
  EndDate: string = '';
  RowOrder: number = 0;
  IsPrimary: boolean = false;
  InsuranceCaseId: number = 0;
  CaseTypeId: number = 0;
  AutharizationName: string = '';
  CaseName: string = '';
  NoOfUnits: number = 0;
  PriorCount: number = 0;
  Active:boolean= false;
  PaymentMethodId: number = 0;
  Authorization: Array<InsuranceCase> = new Array<InsuranceCase>();
  Relationship: string = '';
  CopayAmount: string = '';
  NAME: string = '';
  effectivestartdate: string = '';
  effectiveenddate: string = '';
  InsuranceProviderId: number = 0;
}

export class PatientInsuranceViewModel {
  PatientInsuranceInfo = new PatientInsuranceInfo();
  Masters = new PatientDetailMaster();
}

export class PatientDetailMaster {
 
  Gender: Array<any> = [];
  Suffix: Array<any> = [];
  WeekDay: Array<any> = [];
  Pattern: Array<any> = [];
  MaritalStatus: Array<any> = [];
  SexualOrientation: Array<any> = [];
  ContactType: Array<any> = [];
  PreferredContact: Array<any> = [];
  Race: Array<any> = [];
  ResponsibleParty: Array<any> = [];
  PaymentMethod: Array<any> = [];
  Nationality: Array<any> = [];
  Citizenship: Array<any> = [];
  FirstName: Array<any> = [];
  Language: Array<any> = [];
  AttachmentType: Array<any> = [];
  Ethnicity: Array<any> = [];
  SpecificRace: Array<any> = [];
  Country: Array<any> = [];
  State: Array<any> = [];
  City: Array<any> = [];
  ZipCode: Array<any> = [];
  Hispanic: Array<any> = [];
  MultipleBirthNumber: Array<any> = [];
  Provider: Array<any> = [];
  ReferringProvider: Array<any> = [];
  CaseType: Array<any> = [];
  InsurancePayer: Array<any> = [];
}

export class InsurancePayer extends BaseModel {
  Name: string = '';
  DisplayName: string = '';
  PayerId: string = '';
  PayerType: string = '';
  Description: string = '';
  Services: string = '';
  EnumName: string = '';
  DisplayInList: boolean = true;
  RowOrder: number;
}

export class PatientViewModel {
  Entity = new Patient();
  Masters = new PatientDetailMaster();
}

export class PatientCardDetail {
  CardId: number;
  Name: string;
  Brand: string;
  ExpMonth: number;
  ExpYear: number;
  LastFour: number;
}
